import React, { PropTypes } from 'react';
import PicComponent from './_PicComponent';
import { preloadDefaultSize } from './pic.settings.js';

var Pic = React.createClass({
  displayName: 'Pic',
  propTypes: {
    id: PropTypes.string.isRequired,
    source: PropTypes.string,
    ratio: PropTypes.string,
    preload: PropTypes.bool,
    size: PropTypes.string,
    imageClass: PropTypes.string,
    altText: PropTypes.string,
    version: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
  },
  statics: {
    _getRatiosArray(ratio) {
      return ratio.split(',').map(r => r.trim());
    },
    _getSize(size) {
      if (typeof size === 'number') {
        return size + 'px';
      }
      return size.replace('%', 'vw');
    }
  },
  getDefaultProps() {
    return {
      ratio: 'wide',
      preload: false,
      size: preloadDefaultSize,
      imageClass: ''
    };
  },
  render() {
    var { id, source, altText, ratio, version, preload, size, imageClass, className, ...other} = this.props;
    if(!id) {
      return false;
    }
    var picProps = {
      id: id,
      source: source,
      altText: altText,
      ratios: Pic._getRatiosArray(ratio),
      version: version,
      preload: preload,
      size: Pic._getSize(size),
      imageClass: imageClass,
      className: className,
      ...other
    };
    return (
      <PicComponent {...picProps}>
        {this.props.children}
      </PicComponent>
    );
  }
});

export default Pic;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/Pic.js
 **/